// ── IMAGE SLOTS (ABA Session Ready) ────────────────────────────────
// Hosted in the Impultienda store resources and ebook covers.
const STORE = '9998fbcb-2f38-40da-93fb-a66857002e17';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;
const COVER = (id: string) =>
  `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/render/image/public/ebook-images/${STORE}/${id}-mockup.webp?width=720&quality=85&resize=contain`;

/**
 * iMac + 3 tablets + 2 phones, one bonus per device. Composited in code from the real images (no AI text):
 * the Gamma Studio cover plus real pages 4 and 8 on the iMac, and the Impultienda bonus photos with their
 * titles typed in. Pure white background: show it on bg-white.
 */
const IMAC = RES + '1792593742212_aba-mockup-imac-79c6b1da.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/** Real pages of the Gamma Studio book (9:16), same order as lookInside.captions: p.4, 8, 9, 10, 38, 40. */
export const pageImages: string[] = [
  RES + '1792593746852_aba-pagina-04-plan-q1-f88434b9.webp',
  RES + '1792593752995_aba-pagina-08-programa-01-plan-2b7625fc.webp',
  RES + '1792593757523_aba-pagina-09-programa-01-teach-54f4c121.webp',
  RES + '1792593761929_aba-pagina-10-programa-01-data-92962c88.webp',
  RES + '1792593766655_aba-pagina-38-session-gets-hard-9221b1fd.webp',
  RES + '1792593771635_aba-pagina-40-field-card-424cf266.webp',
];
/** 5 bonus covers, in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  COVER('4b4c2b88-4148-476a-aa63-18378af81c79'),
  COVER('5a947176-cb92-40f3-94af-3f209dd1484e'),
  COVER('799adfc4-4fad-4eb3-8937-9ce595308c7a'),
  COVER('47247f46-1a7e-444c-a61d-3e32a8b338d3'),
  COVER('41530c30-c533-476f-832e-f0b385503091'),
];
